export default __webpack_public_path__ + "static/39ac1f1fce91ef7daf58953a584c2e01.jpeg";